<div #extContainer
     class="flex-column"
     style="height: 100%">

  <div #extHeader
       class="menu-group-head"
       *ngIf="city2 !== null">
    <div class="menu-group-tit only-txt" *ngIf="listVideo">
      <span class="txt" [innerHTML]="GetCity2DisplayTxt(city2) + ' ' + listVideo.length + '개의 이야기' | resize | keepHtml"></span>
    </div>
  </div>


  <div class="menu-group-body flex-grow">
    <div #extBody
         class="video-item-list scroll-effect2 over-y">

      <app-video-item *ngFor="let video of listVideo"
                      [video]="video"></app-video-item>

    </div>

  </div>
</div>
